export default {
  // Nav
  'nav.services': 'サービス',
  'nav.cases': '導入事例',
  'nav.about': '会社概要',
  'nav.contact': 'お問い合わせ',
  'nav.cta': '無料相談',

  // Hero
  'hero.tag': '/ ブロックチェーン・フルサイクル展開',
  'hero.title.line1': 'デジタル製品を',
  'hero.title.line2': '安全にオンチェーンへ',
  'hero.subtitle': 'Angle Forty は、デジタル製品チームがブロックチェーン上で自信を持って展開できるよう、戦略立案から安全なデプロイ、配信、監視、長期的な最適化までをトータルサポートします。',
  'hero.cta.primary': 'オンチェーン展開を始める',
  'hero.cta.secondary': 'サービス詳細を見る',
  'hero.stat.projects': '展開済みプロジェクト',
  'hero.stat.chains': '対応チェーン',
  'hero.stat.uptime': '平均稼働率',
  'hero.stat.experts': '社内専門家',

  // Marquee
  'marquee.item1': 'ETHEREUM · イーサリアム',
  'marquee.item2': 'SOLANA · ソラナ',
  'marquee.item3': 'BNB CHAIN · バイナンスチェーン',
  'marquee.item4': 'POLYGON · ポリゴン',
  'marquee.item5': 'ARBITRUM · アービトラム',
  'marquee.item6': 'BASE · ベース',
  'marquee.item7': 'AVALANCHE · アバランチ',

  // About
  'about.tag': '/ 会社概要',
  'about.title': '戦略から最適化まで、フルサイクルでチェーン上を支援',
  'about.desc': 'Angle Forty は、ブロックチェーンのコアプロトコル、フィンテック、プロダクト運営の各分野から集まったシニアエンジニアとストラテジストによって設立されました。世界中の 120 以上のデジタル製品チームが、安全かつ洗練された方法でオンチェーン展開を実現しています。',
  'about.number': '01',
  'about.number.label': 'フルサイクル・オンチェーンフレームワーク',
  'about.number.desc': '市場調査、トークノミクス設計、スマートコントラクトのデプロイから、配信、データ監視、継続的な最適化まで、4 つのフェーズをシームレスに統合し、クライアントは製品そのものに集中できます。',
  'about.cta': 'フレームワークを詳しく',

  // Services
  'services.tag': '/ コアサービス',
  'services.title.line1': 'オンチェーン展開。',
  'services.title.line2': 'データドリブン成長。',
  'services.desc': '4 つのフェーズ、統合されたワンストップ提供。各ステップは専任のシニアチームが徹底サポートします。',
  'services.s1.title': '戦略・コンサルティング',
  'services.s1.desc': '製品のポジショニング、ターゲットチェーン、トークノミクスを深く分析し、実行可能なオンチェーンロードマップを策定します。',
  'services.s1.tag': 'Phase 01',
  'services.s2.title': 'オンチェーンデプロイ',
  'services.s2.desc': 'スマートコントラクト監査、マルチチェーン展開、高度なセキュリティ対策により、すべての取引と資産の追跡可能性を確保します。',
  'services.s2.tag': 'Phase 02',
  'services.s3.title': 'プロダクト運営',
  'services.s3.desc': '配信、コミュニティ、コンテンツ戦略、キャンペーンを展開し、ターゲットユーザーへ大規模にリーチします。',
  'services.s3.tag': 'Phase 03',
  'services.s4.title': 'サポート・最適化',
  'services.s4.desc': '24 時間 365 日の監視、分析ダッシュボード、継続的な最適化により、市場サイクルを超えて持続可能なプロジェクトを実現します。',
  'services.s4.tag': 'Phase 04',
  'services.s.badge.hot': '注目',

  // Cases
  'cases.tag': '/ 導入事例',
  'cases.title': '信頼されるオンチェーンパートナー',
  'cases.desc': 'NFT デジタルコレクティブルのエンドツーエンド展開 — アート制作からオンチェーンデプロイまで。',
  'cases.viewAll': 'すべての事例を見る',
  'cases.c1.name': 'Pixel Origin',
  'cases.c1.category': 'NFT · アートローンチプラットフォーム',
  'cases.c1.tvl': '取引高 2,800 ETH',
  'cases.c2.name': 'Vault Society',
  'cases.c2.category': 'NFT · メンバーシップパス',
  'cases.c2.tvl': '15,000+ 発行',
  'cases.c3.name': 'MetaForge',
  'cases.c3.category': 'NFT · ゲームアセット',
  'cases.c3.tvl': '取引高 1,200 万ドル',
  'cases.c4.name': 'Eden Drop',
  'cases.c4.category': 'NFT · マーケットプレイス',
  'cases.c4.tvl': '月間アクティブ 28 万',

  // Testimonial
  'testimonial.tag': '/ お客様の声',
  'testimonial.quote': 'Angle Forty は、当初半年かかると見込んでいたマルチチェーン展開をわずか 6 週間で完了させました。ダッシュボードのおかげで、運営チームは初めてオンチェーンビジネスを可視化できるようになりました。',
  'testimonial.author': 'Yvonne Liao',
  'testimonial.role': 'Pixel Origin 共同創業者',
  'testimonial.verified': '認証済みパートナー',

  // CTA
  'cta.tag': '/ お問い合わせ',
  'cta.title': 'オンチェーン展開の準備はできていますか？',
  'cta.desc': 'プロジェクトについてお聞かせください。シニアコンサルタントが 24 時間以内にご連絡し、最適な展開プランをご提案します。',
  'cta.form.name': 'お名前',
  'cta.form.email': 'メールアドレス',
  'cta.form.company': '会社 / プロジェクト名',
  'cta.form.type': 'プロジェクトタイプ',
  'cta.form.type.nft.art': 'NFT アート / デジタルコレクティブル',
  'cta.form.type.nft.gaming': 'NFT ゲームアセット',
  'cta.form.type.nft.membership': 'NFT メンバーシップ / ユーティリティ',
  'cta.form.type.nft.marketplace': 'NFT マーケットプレイス / プラットフォーム',
  'cta.form.type.other': 'その他',
  'cta.form.message': 'プロジェクトについて簡単にご説明ください（500 文字以内）',
  'cta.form.submit': '相談を送信',
  'cta.form.submitting': '送信中…',
  'cta.form.success': 'お問い合わせありがとうございます。24 時間以内にご連絡いたします。',
  'cta.form.error': '送信に失敗しました。後ほど再度お試しいただくか、hello@angleforty.com まで直接メールでご連絡ください。',

  // Footer
  'footer.brandDesc': 'Angle Forty — すべてのデジタル製品を安全かつ洗練された方法でブロックチェーンへ。',
  'footer.nav.title': 'ナビゲーション',
  'footer.contact.title': 'お問い合わせ',
  'footer.social.title': 'フォロー',
  'footer.newsletter': 'ニュースレター購読',
  'footer.newsletter.desc': '月に 1 通。業界の深い洞察と事例の振り返りのみをお届けします。',
  'footer.newsletter.placeholder': 'メールアドレスを入力',
  'footer.newsletter.button': '購読',
  'footer.address.title': '所在地',
  'footer.address.value': '香港中環皇后大道中9号',
  'footer.phone': '+852 3150 0000',
  'footer.email': 'hello@angleforty.com',
  'footer.copyright': '© 2026 Angle Forty Technology Ltd. All rights reserved.',
  'footer.policy.privacy': 'プライバシー',
  'footer.policy.terms': '利用規約',

  // Language
  'lang.zh-Hant': '繁中',
  'lang.zh-Hans': '简中',
  'lang.en': 'EN',
  'lang.ja': '日文',
  'lang.ko': '한국어',
};